import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'page-geodata',
  templateUrl: './geo-data.component.html',
})
export class GeoDataComponent implements OnInit {
  public url = '/api/geodata';

  private geodata: any;

  constructor(public http: HttpClient) {}

  ngOnInit() {
    this.geodata = {
      location: {
        event: 'heartbeat',
        is_moving: false,
        uuid: '5ec4e0e8-70ad-4063-a9cf-b4aa6fa98479',
        timestamp: '2017-09-28T15:22:29.591Z',
        coords: {
          latitude: 52.4786077,
          longitude: -1.8815917,
          accuracy: 20.6,
          speed: -1,
          heading: -1,
          altitude: -1,
        },
        activity: {
          type: 'still',
          confidence: 100,
        },
        battery: {
          is_charging: true,
          level: 0.58,
        },
        extras: {
          taskId: 2,
        },
      },
    };

    this.sendGeoData(this.geodata);
  }

  sendGeoData(geodata) {
    console.log(geodata);
    this.http
      .post(`${this.url}/getgeodatafrommobile`, geodata)
      .toPromise()
      .then((res) => {
        console.log(res);
      })
      .catch((res) => {});
  }
  //public get(): Promise<TreeNode[]> {
  //    return this.http.get(`${this.url}/structure`).toPromise()
  //        .then(this.extractData)
  //        .catch(this.handleError);
  //
  //}
}
